var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Card", {
        scopedSlots: _vm._u([
          {
            key: "head",
            fn: function () {
              return [
                _c("h5", [
                  _vm._v("\n                Submission Checklist "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "red",
                        "font-size": "16px",
                        margin: "0",
                      },
                    },
                    [_vm._v("*")]
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "main",
            fn: function () {
              return [
                _c("p", [
                  _c("strong", [
                    _vm._v(
                      "\n                    Please acknowledge that you have read and understand the following important items before proceeding with submitting your manuscript.\n                "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("check-list", {
                  attrs: { items: _vm.items, "label-key": "content" },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }